import React from 'react';
import classnames from 'classnames';

import { ReactComponent as IconCircle } from './circle.svg';
import { ReactComponent as IconCircleCheck } from './circle-check.svg';

import './context-button.css';

const ContextButton = ({
  title,
  text,
  value,
  isSelected,
  setSelected,
  disabled = false,
}) => {
  const handleCheckboxChange = () => {
    if (disabled) return;
    if (setSelected) {
      setSelected(value);
    }
  };

  return (
    <div
      className={classnames(
        'context-button',
        { selected: isSelected },
        { disabled: disabled },
      )}
      onClick={handleCheckboxChange}
    >
      <div>
        <h2>{title}</h2>
        <p>{text}</p>
      </div>
      {isSelected ? <IconCircleCheck /> : <IconCircle />}
    </div>
  );
};

export default ContextButton;
